module.exports = __webpack_public_path__ + "assets/img/abusiness.ddd6ba66.png";